import 'angular-moment-picker';

import { NgModule } from 'ng-metadata/core';
import { PassportProcessingComponent } from './passport-processing.component';



@NgModule({
  imports: [
    'moment-picker'
  ],
  declarations: [
    PassportProcessingComponent
  ],
})
export class PassportProcessingModule {}



// WEBPACK FOOTER //
// ./resources/assets/js/components/passport-processing/passport-processing.module.ts